var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCryptocurrency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_crypto)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.7656 118.363C123.712 118.363 143.125 98.9504 143.125 75.0037C143.125 51.057 123.712 31.6443 99.7656 31.6443C75.8189 31.6443 56.4062 51.057 56.4062 75.0037C56.4062 98.9504 75.8189 118.363 99.7656 118.363Z",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7656 89.7588C107.92 89.7588 114.531 83.148 114.531 74.9931C114.531 66.8383 107.92 60.2275 99.7656 60.2275C91.6108 60.2275 85 66.8383 85 74.9931C85 83.148 91.6108 89.7588 99.7656 89.7588Z",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.75 46.3972L91.3281 52.9597",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6406 62.5706L78.2031 65.3831",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1719 86.0083L77.7344 83.4301",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3438 102.878L90.1563 96.55",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.777 103.578L108.199 97.0154",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.891 87.4102L121.328 84.5977",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.359 63.9746L121.797 66.5527",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.188 46.8625L109.375 53.425",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.297 150H55.7031C38.8281 150 25 136.172 25 119.297V30.7031C25 13.8281 38.8281 0 55.7031 0H144.063C161.172 0 175 13.8281 175 30.7031V119.063C175 136.172 161.172 150 144.297 150Z",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4531 84.3786V60.4724",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4531 35.3928C44.4531 26.7209 51.4844 19.4553 60.3906 19.4553H139.375C148.047 19.4553 155.312 26.4866 155.312 35.3928V114.377C155.312 123.049 148.281 130.315 139.375 130.315H60.1562C51.4844 130.315 44.2188 123.283 44.2188 114.377V109.455",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.688 67.967V118.358C164.688 130.311 155.078 139.92 143.125 139.92H99.7656",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.688 52.9653V34.9185",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_crypto"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 150,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptocurrency);
export default __webpack_public_path__ + "static/media/cryptocurrency.f8933bd52488d658678d4348952e3a8d.svg";
export { ForwardRef as ReactComponent };